import apiClient from '../client';
import type { Enquiry, CreateEnquiryPayload, UpdateEnquiryPayload } from '@/types';

type EnquiriesListResponse = {
  data: Enquiry[];
  pagination: { total: number; page: number; limit: number; totalPages: number };
};

type EnquiryExportFormat = 'csv' | 'xlsx';

function resolveFilename(contentDisposition: string | undefined, fallback: string) {
  if (!contentDisposition) return fallback;
  const match = contentDisposition.match(/filename="?([^";]+)"?/i);
  return match?.[1] ?? fallback;
}

export const enquiriesApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<EnquiriesListResponse>('/enquiries', { params }).then((r) => r.data),

  exportFile: async (params?: Record<string, unknown> & { format?: EnquiryExportFormat }) => {
    const response = await apiClient.get('/enquiries/export', {
      params,
      responseType: 'blob',
    });

    const format = String(params?.format || 'csv');
    return {
      blob: response.data as Blob,
      filename: resolveFilename(response.headers?.['content-disposition'], `enquiries.${format}`),
    };
  },

  getById: (id: number) =>
    apiClient.get<{ data: Enquiry }>(`/enquiries/${id}`).then((r) => r.data.data),

  create: (payload: CreateEnquiryPayload) =>
    apiClient.post<{ data: Enquiry }>('/enquiries', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateEnquiryPayload) =>
    apiClient.put<{ data: Enquiry }>(`/enquiries/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/enquiries/${id}`),
};

